


















































































































import Vue from 'vue'
import { Route, RawLocation } from 'vue-router'
import { extractTargetFields } from '@/utils/helper'
import Input from '@/components/shared/atoms/Input'
import FormWrapper from '@/components/shared/organisms/FormWrapper'
import FormBlock from '@/components/shared/molecules/Form/FormBlock'
import LinkButton from '@/components/shared/atoms/Button/LinkButton'
import YLoginRegister from '@/components/Auth/YahooLoginButton/Register'
import LinkWithIcon from '@/components/shared/atoms/Icon/LinkWithIcon'
import BackLink from '@/components/shared/atoms/BackLink'
import { EMAIL_DOMAINS } from '@/const'

import SignupAccountValidator, { Fields, FieldErrors } from '@/utils/validators/form/Auth/Signup/Account'
import { encodeEmail } from '@/utils/encode'
import VerifySignupStoreUseCase from '@/usecases/auth/VerifySignupStoreUseCase'

interface IData {
  fields: Fields
  enableCheckFlg: { [key in keyof Fields]: boolean }
  isPasswordInputAssistOpen: boolean
  registeredStoreName: string
}

export default Vue.extend({
  components: {
    Input,
    FormWrapper,
    FormBlock,
    LinkWithIcon,
    LinkButton,
    BackLink,
    YLoginRegister
  },
  props: {
    redirectTo: {
      type: String,
      default: null
    },
    presetEmail: {
      type: String,
      default: null
    },
    token: {
      type: String,
      default: null
    },
    forwardedParams: {
      type: Object as () => Route['params'],
      required: true
    },
    forwardedQueries: {
      type: Object as () => Route['query'],
      required: true
    },
    loginPath: {
      type: [String, Object as () => RawLocation],
      required: true
    },
    hasConflictError: {
      type: Boolean,
      default: () => false
    }
  },
  data(): IData {
    return {
      fields: {
        email: '',
        password: '',
        passwordConfirm: ''
      },
      enableCheckFlg: {
        email: false,
        password: false,
        passwordConfirm: false
      },
      isPasswordInputAssistOpen: false,
      registeredStoreName: ''
    }
  },
  computed: {
    formErrors(): FieldErrors {
      const targetFields = extractTargetFields(this.fields, this.enableCheckFlg)
      return SignupAccountValidator.validate(targetFields)
    },
    isFullfilled(): boolean {
      // TODO: 要改善
      const { email, password, passwordConfirm } = this.fields
      if (email === '') return false
      if (password === '') return false
      if (passwordConfirm === '') return false
      return true
    },
    canSubmit(): boolean {
      const hasErrors = Object.values(this.formErrors).some(field => field.length !== 0)
      return this.isFullfilled && !hasErrors
    },
    suggestions(): string[] {
      const email = this.fields.email
      // /^[^@]+@[^@]+$/.test(email)で書いた場合 文字入力削除を繰り返した場合にめちゃくちゃメモリを食う現象になったため暫定対応
      // TODO: 正規表現で書く
      // @がひとつかつ@以下の入力がある場合にサジェスト
      if ((email.match(/@/g) || []).length === 1 && email.split('@')[1].length) {
        return EMAIL_DOMAINS.map(p => email.split('@')[0] + p)
      }
      return []
    },
    isPasswordFormatLengthClear(): boolean {
      // 半角英数字かつ8文字以上32文字以下
      return /^[A-Za-z0-9]*$/.test(this.fields.password) && this.fields.password.length >= 8 && this.fields.password.length <= 32
    },
    isPasswordFormatNumberClear(): boolean {
      // 数字を1文字含む
      return /^(?=.*[0-9])[^]*$/.test(this.fields.password)
    },
    isPasswordFormatUpperCaseClear(): boolean {
      // 英大文字を1文字含む
      return /^(?=.*[A-Z])[^]*$/.test(this.fields.password)
    },
    isPasswordFormatLowerCaseClear(): boolean {
      // 英大文字を1文字含む
      return /^(?=.*[a-z])[^]*$/.test(this.fields.password)
    },
    isPasswordFormatAllCrear(): boolean {
      // isPasswordFormatXXXを全てクリアしているか
      return this.isPasswordFormatLengthClear && this.isPasswordFormatNumberClear && this.isPasswordFormatLowerCaseClear && this.isPasswordFormatUpperCaseClear
    }
  },
  watch: {
    registeredStoreName: {
      handler() {
        scrollTo(0, 0)
      }
    }
  },
  mounted() {
    const inputFields = this.$profileRepository.getSignupMailAddressInputField()
    // Emailが指定されている場合はそちらの値を利用する
    if (this.presetEmail) {
      this.fields = {
        ...this.fields,
        email: encodeEmail(this.presetEmail)
      }
      this.enableCheck('email')
    } else if (inputFields) {
      this.fields = {
        ...this.fields,
        email: inputFields.email
      }
    }
  },
  methods: {
    enableCheck(str: keyof Fields) {
      this.enableCheckFlg[str] = true
    },
    enableAllChecks() {
      Object.keys(this.fields).forEach(field => this.enableCheck(field as keyof Fields))
    },
    async submit() {
      this.enableAllChecks()
      if (!this.canSubmit) return

      const verifySignupStoreUseCase = new VerifySignupStoreUseCase({
        snapsnapGateway: this.$snapsnapGateway
      })
      try {
        const result = await verifySignupStoreUseCase.execute(this.fields)
        if (result) {
          this.registeredStoreName = result
          return
        }
      } catch (e) {}
      const { email, password } = this.fields
      this.$emit('success', { email, password })
      this.$profileRepository.saveSignupMailAddressInputField({ email })
    },
    passwordCheckFocus() {
      if (this.isPasswordFormatAllCrear) {
        this.isPasswordInputAssistOpen = false
      } else {
        this.isPasswordInputAssistOpen = true
      }
    },
    passwordCheckKeyup() {
      if (this.isPasswordFormatAllCrear && this.isPasswordInputAssistOpen)
        setTimeout(() => {
          this.isPasswordInputAssistOpen = false
        }, 1000)
      if (!this.isPasswordFormatAllCrear) {
        this.isPasswordInputAssistOpen = true
        setTimeout(() => {
          this.isPasswordInputAssistOpen = true
        }, 1000)
      }
    }
  }
})
